import {
  Dialog,
  Icon,
  NewTable,
  SpinningLoader,
  useLanguageSelector,
  useToast,
} from '@vallourec-ui/vallourec-ui'

import { useTranslation } from 'react-i18next'

import React, { useCallback, useEffect, useMemo, useState } from 'react'

import {
  ButtonContainer,
  ColumnContainer,
  Row,
  SpinningContainer,
  StyledButton,
  StyledTextButton,
} from './style'

import { template } from './template'
import { DataResultTemplate } from '@/@types/global'

const DifferentHeaderModal: React.FC<{
  isOpen: boolean
  setIsOpen: (isOpen: boolean) => void
  onOutsideClick: () => void
  onConfirm: () => void
  textButtonConfirm: string
  items: any
}> = ({ isOpen, onOutsideClick, onConfirm, textButtonConfirm, items }) => {
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const { t } = useTranslation()
  const [templateColumnResult, setTemplateColumnResult] = React.useState<any[]>(
    []
  )
  
  const handleOutside = () => {
    onOutsideClick()
  }

  const handleConfirm = () => {
    onConfirm()
    handleOutside()
  }

  useEffect(() => {
    if (isOpen) {
    }
  }, [isOpen])

  useEffect(() => {
    const columns = template.map((elem) => {
      return {
        id: elem.header.split('.').pop(),
        accessorKey: elem.header.split('.').pop(),
        header: t(elem.header),
        cell: ({ cell }) => {
          return <div>{cell.getValue()}</div>
        },
      } as DataResultTemplate
    })
    setTemplateColumnResult(columns)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen])

  const renderTable = useCallback(() => {
    return (
      <>
        <NewTable.Root
          key="Table-with-diff-header"
          columnIdWithRowspan="button"
          columns={templateColumnResult}
          data={items}
          isBordered
          hasScroll
        />
        <Row
          style={{
            justifyContent: 'flex-end',
            marginTop: '15px',
            marginBottom: '15px',
          }}
        >
          <ButtonContainer width="15rem">
            <StyledButton onClick={() => handleOutside()}>
              <StyledTextButton>
                {t<string>('application.button.cancel')}
              </StyledTextButton>
            </StyledButton>
          </ButtonContainer>
          <ButtonContainer width="15rem">
            <StyledButton onClick={() => handleConfirm()}>
              <StyledTextButton>
                <Icon name="DownloadLine2" color="white" />
                {textButtonConfirm}
              </StyledTextButton>
            </StyledButton>
          </ButtonContainer>
        </Row>
      </>
    )
  }, [templateColumnResult, t])

  return (
    <Dialog.Root
      isOpen={isOpen}
      setIsOpen={() => setIsOpen(false)}
      closeOnInteractOutside={false}
      width="80%"
      header={
        <Dialog.Header
          title={t<string>('generateReport.differentHeader.title')}
        />
      }
      footer={
        <></>
      }
    >
      {isLoading ? (
        <SpinningContainer>
          <SpinningLoader />
        </SpinningContainer>
      ) : (
        <ColumnContainer>{renderTable()}</ColumnContainer>
      )}
    </Dialog.Root>
  )
}

export default DifferentHeaderModal
